/**
 * Organizations whose contract restricts where their data may be processed.
 * Selected from authenticated organization scope, never from a model prompt.
 *
 * Every restriction keyed on this list applies to all of them alike: Gateway
 * calls limited to Azure and AWS Bedrock with zero data retention, no direct
 * model APIs, no shared embedding queue, private stored files behind the
 * organization's dedicated workspace server, and no product analytics.
 */
export const IOMFSA_ORGANIZATION_ID = "5e9c2563-b13d-48b1-b44a-f0ed2d36186a";
export const STANDARD_BANK_ORGANIZATION_ID = "532d5e6f-4150-44f3-92f5-7b1130257f0a";
export const KPMG_ORGANIZATION_ID = "5c514f24-63bf-4469-9b0a-ce75be0ad826";

/** Organization id -> the short name in its Gateway reporting tag. */
const RESTRICTED: Readonly<Record<string, string>> = {
  [IOMFSA_ORGANIZATION_ID]: "iomfsa",
  [STANDARD_BANK_ORGANIZATION_ID]: "standardbank",
  [KPMG_ORGANIZATION_ID]: "kpmg",
};

export const RESTRICTED_ORGANIZATION_IDS: ReadonlyArray<string> = Object.keys(RESTRICTED);

export function isRestrictedOrganization(organizationId?: string | null): boolean {
  return typeof organizationId === "string" && Object.hasOwn(RESTRICTED, organizationId.toLowerCase());
}

/** The restricted organization's short name, for reporting; null for any other. */
export function restrictedOrganizationName(organizationId?: string | null): string | null {
  return isRestrictedOrganization(organizationId) ? RESTRICTED[organizationId!.toLowerCase()]! : null;
}

/** No product analytics leave the platform for these organizations. */
export function excludedFromAnalytics(organizationId?: string | null): boolean {
  return isRestrictedOrganization(organizationId);
}
